"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currency = {
    // TODO: Will be used once we add multi-currency
    getCurrency: function (currency) {
        return currency;
    },
};
